import TiptapTable from '@tiptap/extension-table';

export const Table = TiptapTable.configure({ resizable: true });

export default Table;
